
import state from './boardState.js'
import mutations from './boardMutations.js'
import actions from './boardAction.js'
import getters from './boardGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

